export default "__VITE_ASSET__3sJvjJqs__"